import React from 'react';
import { identity, DRAWERS, isMember } from 'utils';
import { AboutAIProps } from 'types/componentTypes/AboutProps';
import { RenderIf } from 'components/components';
import { ViewUploadButton } from 'components/EditAngelInvestor/components';

import './About.scss';

const AboutAI = (props: AboutAIProps) => {
  const {
    title,
    isAngelInvestor,
    angelInvestorDetails,
    status,
    userType,
  } = props;

  const handleOpenDrawer = (drawerBody: string) => {
    props.actions.setIsDrawerOpen({ isDrawerOpen: true });
    props.actions.setDrawerBody({ drawerBody });
  }

  return (
    <div className="about">
      <div className="about__container">
        <RenderIf condition={identity.isTruthyString(title)}>
          <div className="about__header">
            <h3 className="about__title">{title}</h3>
          </div>
        </RenderIf>

        <RenderIf condition={isAngelInvestor}>
          <div className="about__details">
            <div className="details_row">
              <h4>Website:</h4>
              <p>{angelInvestorDetails?.website}</p>
            </div>

            {/* Acceptance Letter Button */}
            <div className="details_row">
              <h4>Acceptance Letter:</h4>
              <div className="acceptance-letter">
                <ViewUploadButton
                  userType={userType}
                  name="Acceptance Letter"
                  onClick={() => handleOpenDrawer(DRAWERS.aIAcceptanceLetterDetails)}
                  condition
                  status={angelInvestorDetails?.acceptanceLetterApprovedStatus}
                  disabled={!status}
                  title={status ? '' : 'Acceptance Letter has not been generated yet. Please check back later.'}
                />
              </div>
            </div>

            {/* ADGM License Button */}
            <div className="details_row">
              <h4>ADGM License:</h4>
              <div>
                <ViewUploadButton
                  userType={userType}
                  name="ADGM License"
                  onClick={() => handleOpenDrawer(DRAWERS.aIAdgmLicenseDetails)}
                  condition
                  status={angelInvestorDetails?.aDGMApprovedStatus}
                  disabled={
                    !(status >= 3)
                    || status === 11
                    || (isMember(userType) && !angelInvestorDetails.currentADGMLicense)
                  }
                  title={status >= 3 ? '' : 'Acceptance Letter must be signed first.'}
                />
              </div>
            </div>

            {/* Incentive Agreement Button */}
            <div className="details_row">
              <h4>Incentive Agreement:</h4>
              <div>
                <ViewUploadButton
                  userType={userType}
                  name="Incentive Agreement"
                  onClick={() => handleOpenDrawer(DRAWERS.aIIncentiveAgreementDetails)}
                  condition
                  status={angelInvestorDetails?.currentIncentiveAgreement?.licenseAgreementStatus}
                  disabled={
                    !(status >= 5)
                    || status === 11
                    || (isMember(userType) && !angelInvestorDetails.currentIncentiveAgreement)
                  }
                  title={status >= 5 ? '' : 'ADGM License must be submitted and approved.'}
                />
              </div>
            </div>
          </div>
        </RenderIf>
      </div>
    </div>
  );
};

export default AboutAI;
